import {
  Stack,
  Box,
  Text,
  AspectRatio,
  UnorderedList,
  ListItem,
  CSSObject,
  StackDirection,
} from '@chakra-ui/react'
import Image from 'next/image'

export interface WidgetProps {
  title: string
  image: string
  list?: string[]
  direction?: StackDirection
  sx?: CSSObject
}

function Widget({
  title,
  image,
  list,
  direction = {
    base: 'column',
    sm: 'row',
    md: 'column',
  },
  sx,
}: WidgetProps): React.ReactElement {
  return (
    <Stack
      spacing="4"
      direction={direction}
      sx={{
        borderRadius: 'md',
        bgColor: 'secondary.950',
        color: 'white',
        px: 6,
        py: 8,
        ...sx,
      }}
    >
      <Box>
        <AspectRatio ratio={1} boxSize={{ base: '56px', sm: '84px' }}>
          <Image src={image} alt="" objectFit="contain" layout="fill" />
        </AspectRatio>
      </Box>
      <Box>
        <Text sx={{ fontSize: { base: 'md', sm: 'lg' }, fontWeight: 'medium' }}>
          {title}
        </Text>
        {list && (
          <UnorderedList
            sx={{
              fontSize: 'lg',
              listStylePosition: 'inside',
              listStyleType: 'none',
              '& li': {
                display: 'flex',
              },
              '& li::before': {
                content: '"•"',
                display: 'inline',
                pr: 2,
              },
            }}
          >
            {list?.map((item, index) => (
              <ListItem key={`${index}`}>{item}</ListItem>
            ))}
          </UnorderedList>
        )}
      </Box>
    </Stack>
  )
}

export default Widget
